export const isMissingDocumentInformation = (user) => {
  const { document_number, document_type } = user;
  return !document_number || !document_number.length || !document_type || !document_type.length;
};
